const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const maxLength = 100
const maxLength255 = 255

const checkAddress = (address) => {
  return address && address.adr && address.adr.length <= maxLength255
}

const checkCodePostal = (address) => {
  return address && address.postal_code && address.postal_code.match(/^\d{5}$/)
}

const checkCity = (address) => {
  return address && address.city
}

const checkEmail = (email) => {
  if (email && (!email.match(emailRegexp) || email.length > maxLength255)) {
    return 'Ce format d’adresse email est invalide'
  }
}

const checkConfirmEmail = (email, confirm) => {
  if (confirm !== email) {
    return 'Les adresses emails ne sont pas identiques'
  }
}

const checkName = (name) => {
  return name && name.match(/[a-zA-Z]+/) && name.length <= maxLength
}

const checkPhone = (phone) => {
  if(phone && !phone.match(/^\d{10}$/)) {
    return 'Le numéro du téléphone est invalide'
  }
}
export {
  checkAddress,
  checkCodePostal,
  checkCity,
  checkEmail,
  checkConfirmEmail,
  checkName,
  checkPhone
}
